import { DateTime } from 'luxon'

// Scans happen in the farms' zone: show every timestamp there, not in the
// browser's, so "rejected at 06:10" means the same as on the scanner.
const ZONE = 'America/Mexico_City'

export const REASONS = ['server_list', 'local_dedupe', 'sticker_not_found']
export const SOURCES = ['picking', 'packing']

// Fixed per reason so a reason keeps its color across charts.
export const REASON_COLORS = {
  server_list: '#b45309',
  local_dedupe: '#557371',
  sticker_not_found: '#9ca3af'
}

export const formatDateTime = value => {
  if (!value) return '-'
  const dt = DateTime.fromISO(String(value)).setZone(ZONE)
  return dt.isValid ? dt.toFormat('dd/MM/yyyy HH:mm:ss') : String(value)
}

export const todayLocal = () => DateTime.now().setZone(ZONE).toFormat('yyyy-MM-dd')

export const daysAgoLocal = days => DateTime.now().setZone(ZONE).minus({ days }).toFormat('yyyy-MM-dd')

// Every yyyy-MM-dd from `from` to `to`, so days without rejections still show.
export const daysBetween = (from, to) => {
  const days = []
  let day = DateTime.fromISO(from)
  const end = DateTime.fromISO(to)
  if (!day.isValid || !end.isValid) return days
  while (day <= end && days.length < 366) {
    days.push(day.toFormat('yyyy-MM-dd'))
    day = day.plus({ days: 1 })
  }
  return days
}

// "06:00:00 / -" style summary of a batch's two reset fields.
export const formatReset = (resetTime, resetEvery) => `${resetTime || '-'} / ${resetEvery || '-'}`

// Builds the query string, skipping empty filters.
export const toQueryString = params => {
  const search = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.append(key, String(value))
  })
  return search.toString()
}
